export var generateRequestString = function (requestArgs) {
    if (requestArgs === void 0) { requestArgs = {}; }
    var query = Object.keys(requestArgs)
        .filter(function (key) { return !!requestArgs[key]; })
        .map(function (key) { return key + "=" + requestArgs[key]; })
        .join('&');
    return query ? "?" + query : '';
};
